/**
 * Static option pools and label tables shared across the insight UI.
 *
 * Branches and payors are NOT here — they come from the server
 * (`dashboard/config`, already scoped to the signed-in user) and are read off
 * the store. The pools below are still seeded and will be replaced as the
 * remaining APIs land.
 */

/**
 * Master switch for the benchmark/target label — the `dl-bench` chips on metric
 * cards, the Current State "Target …" line, the drill-down headers, and the
 * Guide's benchmark column. Hidden for now; flip to `true` to bring them all
 * back. Only the LABELS are gated — benchmark-driven colouring and the chart's
 * reference line are untouched.
 */
export const SHOW_BENCHMARK_LABEL = false;

export const DISCIPLINES = ["RN", "LPN", "PT", "OT", "SLP", "MSW", "HHA"];
export const JOB_TITLES = ["Nurse", "LPN", "Physical Therapist", "Occupational Therapist", "Speech Therapist", "Social Worker", "Home Health Aide"];
export const DISC_TO_JOB: Record<string, string> = { RN: "Nurse", LPN: "LPN", PT: "Physical Therapist", OT: "Occupational Therapist", SLP: "Speech Therapist", MSW: "Social Worker", HHA: "Home Health Aide" };
export const REFERRAL_SOURCES = ["Hospital", "SNF / Facility", "Community", "Physician", "ACO"];
export const SALES_REPS = ["A. Reyes", "M. Chen", "J. Okafor", "S. Patel", "L. Romano", "D. Brooks"];
export const AGING_BUCKETS = ["All", "0–30", "31–60", "61–90", "90+"];
export const COMPARE_PALETTE = ["#4F7396", "#515154", "#5F8F72", "#A37A45"];

export const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MON_FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
